/* iFlip trade-in valuation wizard */
(function () {
  'use strict';
  var root = document.querySelector('[data-tradein]');
  var cfgEl = document.querySelector('[data-ti-config]');
  if (!root || !cfgEl) return;
  var cfg = JSON.parse(cfgEl.textContent);
  var $ = function (s) { return root.querySelector(s); };
  var $$ = function (s) { return Array.prototype.slice.call(root.querySelectorAll(s)); };

  function fmt(n) { return cfg.currency + ' ' + Math.round(n).toString().replace(/\B(?=(\d{3})+(?!\d))/g, ','); }
  function roundTo(n) { var r = parseInt(cfg.round, 10) || 1; return Math.round(n / r) * r; }

  /* Parse "Model | 128GB=90000, 256GB=97000" or "Model | 40000" */
  function parseTable(txt) {
    var out = [];
    (txt || '').split(/\r?\n/).forEach(function (line) {
      line = line.trim();
      if (!line || line.charAt(0) === '#' || line.indexOf('|') < 0) return;
      var parts = line.split('|'), model = parts[0].trim(), spec = parts.slice(1).join('|').trim();
      var prices = [];
      if (/^\d[\d,\s]*$/.test(spec)) prices.push({ size: '', price: parseInt(spec.replace(/[^\d]/g, ''), 10) });
      else spec.split(',').forEach(function (p) {
        var kv = p.split('=');
        if (kv.length === 2) {
          var v = parseInt(kv[1].replace(/[^\d]/g, ''), 10);
          if (v > 0) prices.push({ size: kv[0].trim(), price: v });
        }
      });
      if (model && prices.length) out.push({ model: model, prices: prices });
    });
    return out;
  }
  var brands = {};
  cfg.brands.forEach(function (b) { if (b.name) brands[b.id] = { name: b.name, models: parseTable(b.table) }; });

  var modelSel = $('[data-ti-model]'), storageBox = $('[data-ti-storage]'), upSel = $('[data-ti-upgrade]');
  var stepModel = $('[data-ti-step="model"]'), stepStorage = $('[data-ti-step="storage"]'), stepGrade = $('[data-ti-step="grade"]'), stepUp = $('[data-ti-step="upgrade"]');
  var wa = $('[data-ti-wa]');
  var state = { brand: null, model: null, size: null, base: 0, pct: 0, gradeLabel: '', credit: 0 };

  function renumber() {
    var n = 0;
    $$('.if-ti__step').forEach(function (f) { if (!f.hidden) { n++; var s = f.querySelector('.if-ti__n'); if (s) s.textContent = n; } });
  }

  function onBrand(id) {
    state.brand = brands[id]; state.model = null; state.size = null; state.base = 0;
    var models = state.brand ? state.brand.models : [];
    modelSel.innerHTML = '<option value="">' + (models.length ? 'Select your ' + state.brand.name + ' model' : 'No models listed yet — chat with us on WhatsApp') + '</option>' +
      models.map(function (m, i) { return '<option value="' + i + '">' + m.model.replace(/</g, '&lt;') + '</option>'; }).join('');
    stepModel.disabled = !models.length;
    storageBox.innerHTML = '<span class="if-ti__muted">Select a model first</span>';
    stepStorage.disabled = true; stepStorage.hidden = false;
    renumber(); update();
    modelSel.focus();
  }

  function onModel(idx) {
    state.model = state.brand && state.brand.models[idx] ? state.brand.models[idx] : null;
    state.size = null; state.base = 0;
    if (!state.model) { stepStorage.disabled = true; update(); return; }
    var prices = state.model.prices;
    if (prices.length === 1 && !prices[0].size) {
      stepStorage.hidden = true; state.base = prices[0].price; state.size = '';
    } else {
      stepStorage.hidden = false; stepStorage.disabled = false;
      var def = prices.filter(function (p) { return p.size.toUpperCase() === '128GB'; })[0] || prices[0];
      storageBox.innerHTML = prices.map(function (p, i) {
        var id = 'ti-s-' + i;
        return '<input type="radio" name="ti-storage" id="' + id + '" value="' + i + '"' + (p === def ? ' checked' : '') + '><label for="' + id + '">' + p.size + '</label>';
      }).join('');
      state.size = def.size; state.base = def.price;
    }
    stepGrade.disabled = false;
    if (stepUp) stepUp.disabled = false;
    renumber(); update();
  }

  function update() {
    var g = root.querySelector('input[name="ti-grade"]:checked');
    state.pct = g && !stepGrade.disabled ? parseInt(g.value, 10) : 0;
    state.gradeLabel = g ? g.getAttribute('data-label') : '';
    var device = state.model ? (state.brand.name.indexOf('Apple') === 0 && state.model.model.indexOf('iPhone') === 0 ? 'Apple ' : '') + state.model.model + (state.size ? ' (' + state.size + ')' : '') : '';
    state.credit = state.base && state.pct ? roundTo(state.base * state.pct / 100) : 0;

    $('[data-ti-out-device]').textContent = device || '—';
    $('[data-ti-out-grade]').textContent = state.pct ? state.gradeLabel : '—';
    $('[data-ti-out-credit]').textContent = state.credit ? fmt(state.credit) : cfg.currency + ' —';
    root.querySelector('[data-ti-est]').classList.toggle('is-ready', !!state.credit);

    /* upgrade & net top-up */
    var net = $('[data-ti-net]'), upName = '', netVal = '';
    if (upSel && upSel.value && state.credit) {
      var opt = upSel.options[upSel.selectedIndex], price = parseInt(upSel.value, 10) / 100;
      upName = opt.textContent.split(' — ')[0];
      var top = Math.max(0, price - state.credit);
      var L = window.iflipLipa, dep, monthly, months = cfg.months;
      if (L) { var pl = L.plan(top, L.deposits[0] || cfg.depositPct, L.popular); dep = pl.deposit; monthly = pl.installment; months = pl.count; }
      else { dep = roundTo(top * (cfg.depositPct / 100)); monthly = cfg.months ? roundTo((top - dep) / cfg.months) : 0; }
      $('[data-ti-out-new]').textContent = fmt(price);
      $('[data-ti-out-less]').textContent = '− ' + fmt(state.credit);
      $('[data-ti-out-net]').textContent = fmt(top);
      $('[data-ti-out-lipa]').textContent = top > 0 ? fmt(dep) + ' deposit + ' + fmt(monthly) + ' × ' + months + ' mo' : 'Fully covered';
      netVal = fmt(top);
      net.hidden = false;
    } else if (net) net.hidden = true;

    /* WhatsApp lock-in */
    var msg = 'Hello iFlip Store Kenya, I would like to lock in my trade-in:\n' +
      '• Device: ' + (device || '-') + '\n• Condition: ' + (state.gradeLabel || '-') + '\n• Estimated credit: ' + (state.credit ? fmt(state.credit) : '-') +
      (upName ? '\n• Upgrade to: ' + upName + '\n• Net top-up: ' + netVal : '');
    wa.href = 'https://wa.me/' + cfg.wa + '?text=' + encodeURIComponent(msg);
    wa.classList.toggle('is-disabled', !state.credit);

    /* booking form hidden fields */
    var set = function (sel, v) { var el = document.querySelector(sel); if (el) el.value = v || ''; };
    set('[data-ti-h-device]', device);
    set('[data-ti-h-grade]', state.pct ? state.gradeLabel + ' — ' + state.pct + '%' : '');
    set('[data-ti-h-credit]', state.credit ? fmt(state.credit) : '');
    set('[data-ti-h-upgrade]', upName);
    set('[data-ti-h-net]', netVal);
  }

  root.addEventListener('change', function (e) {
    var t = e.target;
    if (t.name === 'ti-brand') onBrand(t.value);
    else if (t === modelSel) onModel(t.value);
    else if (t.name === 'ti-storage') {
      var p = state.model.prices[parseInt(t.value, 10)]; state.size = p.size; state.base = p.price; update();
    } else if (t.name === 'ti-grade' || t === upSel) update();
  });

  /* Prefill from URL, e.g. /pages/trade-in?brand=1 */
  var qb = new URLSearchParams(window.location.search).get('brand');
  if (qb && brands[qb]) { var r = root.querySelector('input[name="ti-brand"][value="' + qb + '"]'); if (r) { r.checked = true; onBrand(qb); } }
  update();
})();
